import Integrations from "./integrationsContainer";
export default Integrations;